import { plural } from '@cian/utils';
import { NBSP } from '../../constants/symbols';

export enum EPluralCase {
  // Именительный падеж
  Nominative,
  // Родительный падеж
  Genitive,
}

type TPluralCases = {
  [key in EPluralCase]: [string, string, string];
};

const PLURAL_CASES: TPluralCases = {
  // 1 день, 2 дня, 5 дней
  [EPluralCase.Nominative]: ['день', 'дня', 'дней'],
  // в течение 1 дня, 2 дней, 5 дней
  [EPluralCase.Genitive]: ['дня', 'дней', 'дней'],
};

/**
 *
 * @description Склоняет дни в указанном падеже
 */
export function pluralDays(days: number, pluralCase: EPluralCase = EPluralCase.Nominative) {
  return `${days}${NBSP}${plural(days, PLURAL_CASES[pluralCase])}`;
}
